export enum SearchParam {
  Organization = 'organization',
}
